import { mapState } from "vuex";

export default {
  data() {
    return {
      form: {},
      errors: {},
      loading: false,
      currentStep: 2,
      showSuccessModal: false
    };
  },
  computed: {
    ...mapState("product", ["products", "product", "classes"])
  },
  methods: {
    getCategories() {
      this.$store
        .dispatch("product/getCategories")
        .then()
        .catch(error => {
          this.errors = error.response.data;

          if (this.errors.non_field_errors) {
            this.$message.error(this.errors.non_field_errors[0]);
          }

          if (this.errors.details) {
            this.$message.error(this.errors.details);
          }

          if (error.response.data.status === 401) {
            this.$message.error("Token inválido");
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async submitProduct(form, showSuccess = true, price = null) {
      if (this.loading) return;
      this.loading = true;
      /*
       * In product of type signature the price is in plan,
       * but I need send price in products to,
       * Then I'm sending the same price of the first plan
       *
       */
      let data = form;
      if (price) {
        data = {
          ...data,
          price
        };
      }

      data.price_eur = data.price_eur === 0 ? "" : data.price_eur;
      data.price_usd = data.price_usd === 0 ? "" : data.price_usd;

      return new Promise((resolve, reject) => {
        this.$store
          .dispatch("product/post", data)
          .then(response => {
            this.submitSuccess();
            resolve(response);
          })
          .catch(error => {
            if (error.response && error.response.data) {
              this.errors = error.response ? error.response.data : {};
              let msg = [];
              for (let i in this.errors) {
                for (let j in this.errors[i]) {
                  if (typeof this.errors[i][j] === "string") {
                    msg.push(`${i}: ${this.errors[i][j]}`);
                  } else {
                    for (let k in this.errors[i][j]) {
                      msg.push(`${i}: ${this.errors[i][j][k]}`);
                    }
                  }
                }
              }
              if (msg.length) {
                this.$message.error(msg.join(". "));
              }
            }
            reject(error);
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },
    submitSuccess() {
      this.$router.push({
        name: "product-details",
        params: { id: this.product.id }
      });
    }
  }
};
